import { apiClient, unwrapApi } from './http';

/**
 * Customers API — /customers/*
 */
export async function getCustomers(params = {}) {
  const { data } = await apiClient.get('/customers', { params });
  return unwrapApi(data);
}

export async function searchCustomers(q) {
  const { data } = await apiClient.get('/customers/search', { params: { q } });
  return unwrapApi(data);
}

export async function getCustomer(id) {
  const { data } = await apiClient.get(`/customers/${id}`);
  return unwrapApi(data);
}

export async function createCustomer(payload) {
  const { data } = await apiClient.post('/customers', payload);
  return unwrapApi(data);
}

export async function updateCustomer(id, payload) {
  const { data } = await apiClient.put(`/customers/${id}`, payload);
  return unwrapApi(data);
}

export async function deleteCustomer(id) {
  const { data } = await apiClient.delete(`/customers/${id}`);
  return unwrapApi(data);
}

export async function getCustomerStatsOverview() {
  const { data } = await apiClient.get('/customers/stats/overview');
  return unwrapApi(data);
}

const customersService = {
  getCustomers,
  searchCustomers,
  getCustomer,
  createCustomer,
  updateCustomer,
  deleteCustomer,
  getCustomerStatsOverview,
};

export default customersService;
